"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtCalendar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtCalendar = function SvgBtCalendar(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#sb_calendar__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.1666 22.0001H7.83337C6.82202 22.0001 6 21.1781 6 20.1667V9.16675C6 8.1554 6.82202 7.3335 7.83337 7.3335H20.1666C21.178 7.3335 22 8.1554 22 9.16675V20.1667C22 21.1781 21.178 22.0001 20.1666 22.0001ZM7.83337 8.3335C7.37402 8.3335 7 8.7074 7 9.16675V20.1667C7 20.6261 7.37402 21.0001 7.83337 21.0001H20.1666C20.626 21.0001 21 20.6261 21 20.1667V9.16675C21 8.7074 20.626 8.3335 20.1666 8.3335H7.83337Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.5 12.3335H6.5C6.224 12.3335 6 12.1095 6 11.8335C6 11.5575 6.224 11.3335 6.5 11.3335H21.5C21.776 11.3335 22 11.5575 22 11.8335C22 12.1095 21.776 12.3335 21.5 12.3335Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.83331 10C9.55731 10 9.33331 9.776 9.33331 9.5V6.5C9.33331 6.224 9.55731 6 9.83331 6C10.1093 6 10.3333 6.224 10.3333 6.5V9.5C10.3333 9.776 10.1093 10 9.83331 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.1667 10C17.8907 10 17.6667 9.776 17.6667 9.5V6.5C17.6667 6.224 17.8907 6 18.1667 6C18.4427 6 18.6667 6.224 18.6667 6.5V9.5C18.6667 9.776 18.4427 10 18.1667 10Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "sb_calendar__clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  }))));
};

exports.SvgBtCalendar = SvgBtCalendar;